import { Table as TableIcon } from 'lucide-react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@shadcn/components/ui/table';
import { classNames as cn } from '~/utils/classNames';

interface ResultsTableProps {
  data: any[];
  onRowClick?: (row: any) => void;
  isDefaultQuery: boolean;
  defaultLimit?: number;
}

export function ResultsTable({ data, onRowClick, isDefaultQuery, defaultLimit }: ResultsTableProps) {
  if (!data || data.length === 0) {
    return <p className="p-4 text-center">The query returned no results.</p>;
  }

  const headers = Object.keys(data[0]);

  return (
    <div className="overflow-auto px-6 lg:px-8 ">
      <div className="flex items-center justify-between rounded-t-md bg-bolt-ds-surfaceThree/30 px-6 py-2 w-full mb-[-1px]">
        <div className="flex gap-2 items-center">
          <TableIcon strokeWidth={1.5} size={16} />
          <span className="font-semibold text-sm">Records</span>
          <div className="text-xs py-1.5 px-2 rounded-lg bg-bolt-ds-surfaceThree/80 ml-1">{data.length} rows</div>
        </div>
        {isDefaultQuery && (
          <span className="text-sm text-bolt-ds-textSecondary">Showing up to {defaultLimit} records</span>
        )}
      </div>
      <Table className="border border-bolt-ds-borderOutline rounded-md">
        <TableHeader>
          <TableRow className="hover:bg-transparent">
            {headers.map((header) => (
              <TableHead className="first:pl-6 lg:first:pl-8 last:pr-6 lg:last:pr-8" key={header}>
                {header}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((row, rowIndex) => (
            <TableRow
              key={rowIndex}
              onClick={() => onRowClick?.(row)}
              className={cn(onRowClick && 'cursor-pointer hover:bg-bolt-ds-surfaceThree/50 group')}
            >
              {headers.map((header) => (
                <TableCell
                  className="first:pl-6 lg:first:pl-8 last:pr-6 lg:last:pr-8 text-xs text-bolt-ds-textSecondary group-hover:text-bolt-ds-textPrimary min-w-[8rem]"
                  key={`${rowIndex}-${header}`}
                >
                  <div className="text-xs font-mono w-fit max-w-96 truncate">
                    {JSON.stringify(row[header]).replace(/^"|"$/g, '')}
                  </div>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
